/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLoginIp
 */
export interface ControlLoginIp {
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    ip_address: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLoginIp
     */
    timestamp: string;
}

/**
 * Check if a given object implements the ControlLoginIp interface.
 */
export function instanceOfControlLoginIp(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "ip_address" in value;
    isInstance = isInstance && "timestamp" in value;

    return isInstance;
}

export function ControlLoginIpFromJSON(json: any): ControlLoginIp {
    return ControlLoginIpFromJSONTyped(json, false);
}

export function ControlLoginIpFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLoginIp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'entity_id': json['entity_id'],
        'ip_address': json['ip_address'],
        'timestamp': json['timestamp'],
    };
}

export function ControlLoginIpToJSON(value?: ControlLoginIp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'entity_id': value.entity_id,
        'ip_address': value.ip_address,
        'timestamp': value.timestamp,
    };
}

